/* eslint-disable no-restricted-properties */

export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

export const setToken = async (token: string): Promise<void> => {
  window.localStorage.setItem('token', token);
};

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
};
